module.exports = __webpack_public_path__ + "img/facebookIcon.361e7c60.png";